import axios, { AxiosResponse } from 'axios';
import { CommonService } from './common.services';
import { Acreditado, ConfiguracionMeeting, Cronograma, DashboardMeeting, DetalleAgenda, Empresa, ItemMeeting, MensajeMeeting, TipoAcreditado } from './suite.interfaces';

export class MeetingService extends CommonService {

  async findByContext(context: string): Promise<ConfiguracionMeeting> {
    try {
      const response: AxiosResponse<ConfiguracionMeeting> = await axios.get(this.getServerUrl() + '/meetings/findByContext?context=' + context, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findDashboarBy(evento: number, hash: string): Promise<DashboardMeeting> {
    try {
      const response: AxiosResponse<DashboardMeeting> = await axios.get(this.getServerUrl() + '/meetings/findDashboardBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findAcreditadoMeetingBy(evento: number, hash: string): Promise<Acreditado> {
    try {
      const response: AxiosResponse<Acreditado> = await axios.get(this.getServerUrl() + '/meetings/findAcreditadoMeetingBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findEmpresaAcreditadoBy(evento: number, hash: string): Promise<Empresa> {
    try {
      const response: AxiosResponse<Empresa> = await axios.get(this.getServerUrl() + '/meetings/findEmpresaAcreditadoBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async saveEmpresa(evento: number, hash: string, empresa: Empresa) {
    try {
      const response: AxiosResponse<String> = await axios.post(super.getServerUrl() + '/meetings/saveEmpresa?evento=' + evento + '&hash=' + hash, empresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "OK");
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async updateEmpresa(evento: number, hash: string, empresa: Empresa) {
    try {
      const response: AxiosResponse<String> = await axios.post(super.getServerUrl() + '/meetings/updateEmpresa?evento=' + evento + '&hash=' + hash, empresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "OK");
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findTiposAcreditadosSolicitablesBy(evento: number, hash: string): Promise<TipoAcreditado[]> {
    try {
      const response: AxiosResponse<TipoAcreditado[]> = await axios.get(this.getServerUrl() + '/meetings/findTiposAcreditadosSolicitablesBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findTiposAcreditadosSolicitantesBy(evento: number): Promise<TipoAcreditado[]> {
    try {
      const response: AxiosResponse<TipoAcreditado[]> = await axios.get(this.getServerUrl() + '/meetings/findTiposAcreditadosSolicitantesBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findItemsMeetingBy(evento: number, hash: string): Promise<ItemMeeting[]> {
    try {
      const response: AxiosResponse<ItemMeeting[]> = await axios.get(this.getServerUrl() + '/meetings/findItemsMeetingBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findCitasDisponiblesBy(evento: number, hash: string, fecha: string, itemMeeting: ItemMeeting): Promise<Cronograma[]> {
    try {
      fecha = encodeURIComponent(fecha);
      const item = { "itemMeeting": itemMeeting };
      const response: AxiosResponse<Cronograma[]> = await axios.post(this.getServerUrl() + '/meetings/findCitasDisponiblesBy?evento=' + evento + '&hash=' + hash + '&fecha=' + fecha, item, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findCitasDisponiblesFechaBy(evento: number, hash: string, fecha: string): Promise<Cronograma[]> {
    try {
      fecha = encodeURIComponent(fecha);
      const response: AxiosResponse<Cronograma[]> = await axios.get(this.getServerUrl() + '/meetings/findCitasDisponiblesFechaBy?evento=' + evento + '&hash=' + hash + '&fecha=' + fecha, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async reservarCita(evento: number, hash: string, idCronograma: number, idAcreditadoSolicitado: number, observaciones: string): Promise<boolean> {
    try {
      const response: AxiosResponse<string> = await axios.post(this.getServerUrl() + '/meetings/reservarCita?evento=' + evento + '&cronograma=' + idCronograma + '&acreditadoSolicitado=' + idAcreditadoSolicitado + '&hash=' + hash, observaciones, { headers: { "Authorization": this.token, "Client-ID": this.clientId, "Content-Type": "text/plain" } });
      return (response.data as string == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findFechasBy(evento: number): Promise<string[]> {
    try {
      const response: AxiosResponse<string[]> = await axios.get(this.getServerUrl() + '/meetings/findFechasBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findDetalleAgendaBy(evento: number, hash: string, tipo: number): Promise<DetalleAgenda[]> {
    try {
      const response: AxiosResponse<DetalleAgenda[]> = await axios.get(this.getServerUrl() + '/meetings/findDetalleAgendaBy?evento=' + evento + '&hash=' + hash + '&tipo=' + tipo, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findDetalleAgendaFechaBy(evento: number, hash: string, tipo: number, fecha: string): Promise<DetalleAgenda[]> {
    try {
      fecha = encodeURIComponent(fecha);
      const response: AxiosResponse<DetalleAgenda[]> = await axios.get(this.getServerUrl() + '/meetings/findDetalleAgendaBy?evento=' + evento + '&hash=' + hash + '&tipo=' + tipo + '&fecha=' + fecha, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async bloquear(evento: number, hash: string, idCronograma: number, observaciones: string): Promise<boolean> {
    try {
      observaciones = encodeURIComponent(observaciones);
      const response: AxiosResponse<string> = await axios.get(this.getServerUrl() + '/meetings/bloquear?evento=' + evento + '&cronograma=' + idCronograma + '&observaciones=' + observaciones + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async bloquearDiaCompleto(evento: number, hash: string, fecha: string): Promise<boolean> {
    try {
      fecha = encodeURIComponent(fecha);
      const response: AxiosResponse<string> = await axios.get(this.getServerUrl() + '/meetings/bloquearDiaCompleto?evento=' + evento + '&fecha=' + fecha + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async desbloquear(evento: number, hash: string, idAgenda: number): Promise<boolean> {
    try {
      const response: AxiosResponse<string> = await axios.get(this.getServerUrl() + '/meetings/desbloquear?evento=' + evento + '&agenda=' + idAgenda + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async cancelar(evento: number, hash: string, idAgenda: number): Promise<boolean> {
    try {
      const response: AxiosResponse<string> = await axios.get(this.getServerUrl() + '/meetings/cancelar?evento=' + evento + '&agenda=' + idAgenda + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async cambiarEstado(evento: number, hash: string, idAgenda: number, idEstado: number, observaciones: string): Promise<boolean> {
    try {
      observaciones = encodeURIComponent(observaciones);
      const response: AxiosResponse<string> = await axios.post(this.getServerUrl() + '/meetings/cambiarEstadoCita?evento=' + evento + '&agenda=' + idAgenda + '&idEstado=' + idEstado + '&hash=' + hash, observaciones, { headers: { "Authorization": this.token, "Client-ID": this.clientId, "Content-Type": "text/plain" } });
      return (response.data as string == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findMensajesBy(evento: number, hash: string): Promise<MensajeMeeting[]> {
    try {
      const response: AxiosResponse<MensajeMeeting[]> = await axios.get(this.getServerUrl() + '/meetings/findMensajesBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findConversacionBy(evento: number, hash: string, idAcreditadoConversacion: number): Promise<MensajeMeeting[]> {
    try {
      const response: AxiosResponse<MensajeMeeting[]> = await axios.get(this.getServerUrl() + '/meetings/findConversacionBy?evento=' + evento + '&hash=' + hash + '&acreditado=' + idAcreditadoConversacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async responder(evento: number, hash: string, idAcreditadoPara: number, mensaje: string): Promise<boolean> {
    try {
      const response: AxiosResponse<string> = await axios.post(this.getServerUrl() + '/meetings/responder?evento=' + evento + '&hash=' + hash + '&acreditado=' + idAcreditadoPara, mensaje, { headers: { "Authorization": this.token, "Client-ID": this.clientId, "Content-Type": "text/plain" } });
      return (response.data as string == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async sendInvitacionMeeting(evento: number, hash: string, empresa: number, mail: string): Promise<boolean> {
    try {
      const response: AxiosResponse<string> = await axios.get(this.getServerUrl() + '/meetings/sendInvitacionMeeting?evento=' + evento + '&hash=' + hash + '&empresa=' + empresa + '&mail=' + mail, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async downloadAgendaPdf(evento: number, hash: string, lang: string): Promise<void> {
    try {
      const response: AxiosResponse<Blob> = await axios.get(
        this.getServerUrl() + `/meetings/getAgendaPdf?evento=${evento}&hash=${hash}&lang=${lang}`, { responseType: 'blob', headers: { "Authorization": this.token, "Client-ID": this.clientId } });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      let filename = 'agenda.pdf';
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match) filename = match[1];
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      throw this.manageError(error);
    }
  }
}
